import axios from 'axios';
import { COOKIE_KEYS } from 'config/cookieConstants';
import Cookies from 'js-cookie';
import { AppRoutes } from 'routes/AppRoutes';
import { message } from 'antd';

// Criação da instância base do Axios
const BaseAPI = axios.create({
    baseURL: process.env.REACT_APP_API_URL ||
        // 'http://localhost:8000/',
        'https://lass-api.dev.stoomlab.com.br/',
    // 'https://lass-api.stoom.com.br/',
    headers: {
        'Content-Type': 'application/json',
    },
});

// Intercepta todas as requisições para adicionar um token, se necessário
BaseAPI.interceptors.request.use(config => {
    const token = Cookies.get(COOKIE_KEYS.TOKEN);

    if (token) {
        config.headers.Authorization = `Token ${token}`;
    }

    const companyUuid = Cookies.get(COOKIE_KEYS.COMPANY_UUID);
    if (companyUuid) {
        config.headers['X-Company-UUID'] = companyUuid;
    }

    if (config?.headers) {
        config.headers['2fa'] = config.headers.code;
        delete config.headers.code;
    }

    return config;
}, error => {
    return Promise.reject(error);
});

// Intercepta todas as respostas para tratamento de erros global
BaseAPI.interceptors.response.use(
    (response) => {
        // Caso a resposta seja bem-sucedida, retorna a response
        return response;
    },
    (error) => {
        if (error.response && error.response.status === 401) {
            message.error("Sessão expirada! Realize login novamente para seguir.")
            Object.values(COOKIE_KEYS).forEach(cookieName => {
                Cookies.remove(cookieName);
            });
            window.location.href = AppRoutes.LOGIN;
        }

        // Retorna o erro para que o chamador possa tratá-lo
        return Promise.reject(error);
    }
);

export default BaseAPI;
